/**
 * True when a stored or presigned media URL points at a PDF.
 *
 * A stored key or URL carries no MIME type, so this reads the extension, ignoring the
 * query string a presigned URL appends. Used to keep a PDF cover (the offer cover accepts
 * one) out of an `<img>`, where it would render as a broken image.
 */
export function isPdfUrl(url: string | null | undefined): boolean {
  return /\.pdf($|\?)/i.test(url ?? '');
}
